import TipoProdutoService from "@/services/TipoProdutoService";

export const tipoProduto = {
  namespaced: true,
  state: {
    tipoProduto: {},
  },
  actions: {
    getTipoProduto({ commit }, payload) {
      return TipoProdutoService.GetTipoProduto(payload).then(
        (tipoProduto) => {
          return Promise.resolve(tipoProduto);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postTipoProduto({ commit }, payload) {
      return TipoProdutoService.PostTipoProduto(payload).then(
        (tipoProduto) => {
          return Promise.resolve(tipoProduto);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putTipoProduto({ commit }, payload) {
      return TipoProdutoService.PutTipoProduto(payload).then(
        (tipoProduto) => {
          return Promise.resolve(tipoProduto);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteTipoProduto({ commit }, payload) {
      return TipoProdutoService.DeleteTipoProduto(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getTipoProdutoOData({ commit }, payload) {
      return TipoProdutoService.GetTipoProdutoOData(payload).then(
        (tipoProduto) => {
          return Promise.resolve(tipoProduto);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default tipoProduto;
